import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PublicLayoutHeader } from './PublicLayoutHeader';
import { FloatingCTAActions } from '@/components/FloatingCTAActions';
import { SignOutButton } from '@/components/SignOutButton/SignOutButton';
import { SkipToContent } from '@/components/SkipToContent';
import { privateMeta } from '@/lib/seo/site';
import { useSeoHead } from '@/lib/seo/useSeoHead';

const NAV_ITEMS = [
  { to: '/dashboard', key: 'overview', end: true },
  { to: '/dashboard/profile', key: 'profile' },
  { to: '/dashboard/saved', key: 'saved' },
  { to: '/dashboard/requests', key: 'requests' },
  { to: '/dashboard/history', key: 'history' },
] as const;

// No <Footer /> here: the dashboard behaves like an app shell, the public
// footer stays on PublicLayout routes only (client 2026-06-04).
export function BuyerLayout() {
  const { t } = useTranslation();
  useSeoHead(privateMeta('My Dashboard'));

  return (
    <div className="layout layout--public buyer-layout">
      <SkipToContent />
      <PublicLayoutHeader />
      <div className="buyer-shell">
        <nav className="buyer-sidebar" aria-label={t('buyer.nav.label')}>
          <div className="buyer-sidebar__group">
            <div className="buyer-sidebar__group-label">{t('buyer.nav.section')}</div>
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={'end' in item ? item.end : false}
                className="buyer-sidebar__link"
              >
                {t(`buyer.nav.${item.key}`)}
              </NavLink>
            ))}
          </div>
          <SignOutButton variant="public" className="btn btn--primary buyer-sidebar__signout" />
        </nav>
        <main id="main-content" tabIndex={-1} className="buyer-main">
          <Outlet />
        </main>
      </div>
      <FloatingCTAActions variant="whatsapp-only" />
    </div>
  );
}
